import type { FantasyCardTypeId } from '~/types/fantasy'

export const DOTA_GROUPS_ORDER: FantasyCardTypeId[] = [
  'main',
  'middle',
  'support'
]

export const CARD_SELECT_ITEMS_PER_PAGE = 4
